import { jsxs as _, jsx as l } from "react/jsx-runtime";
import f from "clsx";
const t = (a) => f(a), e = "dds-panel-v0183";
function p({
  children: a,
  className: c = "",
  contentClassName: n = "",
  contentWell: m,
  footer: d,
  footerActions: i,
  footerVariant: h = "default",
  header: r,
  headerActions: s,
  noContentPadding: v,
  isLoading: $ = !1,
  ...N
}) {
  const o = {
    [e]: !0,
    [`${e}--footer-${h}`]: !0,
    [`${e}--loading`]: $,
    [c]: c.length > 0
  };
  return /* @__PURE__ */ _("div", { className: t(o), ...N, children: [
    $ && /* @__PURE__ */ l("div", { className: `${e}__loader`, children: /* @__PURE__ */ l("div", { className: `${e}__loaderAnimation` }) }),
    (r || s) && /* @__PURE__ */ _("div", { className: `${e}__header`, children: [
      r && /* @__PURE__ */ l("div", { className: `${e}__header-left`, children: r }),
      s && /* @__PURE__ */ l("div", { className: `${e}__header-right`, children: s })
    ] }),
    m && /* @__PURE__ */ l("div", { className: `${e}__content-well`, children: m }),
    /* @__PURE__ */ l(
      "div",
      {
        className: t({
          [`${e}__inner`]: !0,
          [`${e}__innerPadding`]: !v,
          [n]: n.length > 0
        }),
        children: a
      }
    ),
    (d || i) && /* @__PURE__ */ _("div", { className: `${e}__footer`, children: [
      d && /* @__PURE__ */ l("div", { className: `${e}__footer-left`, children: d }),
      i && /* @__PURE__ */ l("div", { className: `${e}__footer-right`, children: i })
    ] })
  ] });
}
export {
  p as Panel
};
//# sourceMappingURL=index.js.map
